export function getTableColumns(rows) {
  return rows.map((row) => ({
    ...row,

    tagNumber: row.tagNumber,
    serialNumberVin: row.vin,
    standardItemNumber: row.standardItemNumber,
  }));
}
